// import React, { useEffect, useState } from 'react';

// import { IMG_PLACEHOLDER } from '@/ux-legacy/uikit/utils/img-placeholder';

// import MediaUploadIndicator from '../bentoboard/Options/MediaUploadIndicator';

// const RefreshableImage = ({
//   src,
//   classNames,
//   style,
//   onMouseEnter,
//   onMouseLeave,
//   id,
//   defaultUserProfile,
//   isDraggable = false,
// }: {
//   src: string;
//   classNames?: string;
//   style?: any;
//   onMouseEnter?: any;
//   onMouseLeave?: any;
//   id?: string;
//   defaultUserProfile?: string;
//   isDraggable?: boolean;
// }) => {
//   const [imageLoaded, setImageLoaded] = useState(false);
//   const [showProgress, setShowProgress] = useState<boolean>(false);
//   const [imageUrl, setImageUrl] = useState<any>(src);

//   useEffect(() => {
//     let count = 0;
//     const loadImage = () => {
//       setImageLoaded(false);
//       setShowProgress(true);
//       const image = new Image();
//       image.src = src;
//       image.onload = () => {
//         setImageLoaded(true);
//         setShowProgress(false);
//         setImageUrl(src);
//       };

//       image.onerror = () => {
//         setImageUrl(defaultUserProfile || IMG_PLACEHOLDER);

//         if (count <= 5) {
//           poll();
//           count++;
//         } else {
//           setShowProgress(false);
//         }
//       };
//     };

//     const pollingInterval = 1000;

//     const poll = () => {
//       if (!imageLoaded && src != undefined) {
//         setTimeout(() => {
//           loadImage();
//         }, pollingInterval);
//       }
//     };

//     loadImage();
//   }, [imageLoaded, src]);

//   return (
//     <div className="w-full h-full flex relative ">
//       {showProgress && (
//         <div className="absolute top-2 left-2.5 z-10 ">
//           <MediaUploadIndicator percentage={50} />
//         </div>
//       )}
//       <img
//         src={imageUrl}
//         className={` ${classNames ? classNames : 'w-full h-full object-cover'}`}
//         alt="refreshable"
//         onMouseLeave={onMouseLeave}
//         onMouseEnter={onMouseEnter}
//         draggable={isDraggable}
//       />
//     </div>
//   );
// };

// export default RefreshableImage;

import React, { useEffect, useState } from 'react';

import { IMG_PLACEHOLDER } from '@/ux-legacy/uikit/utils/img-placeholder';

import MediaUploadIndicator from '../bentoboard/Options/MediaUploadIndicator';

const RefreshableImage = ({
  src,
  classNames,
  style,
  onMouseEnter,
  onMouseLeave,
  id,
  defaultUserProfile,
  isDraggable = false,
}: {
  src: string;
  classNames?: string;
  style?: any;
  onMouseEnter?: any;
  onMouseLeave?: any;
  id?: string;
  defaultUserProfile?: string;
  isDraggable?: boolean;
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>(
    src && src.trim() !== '' ? src : defaultUserProfile || IMG_PLACEHOLDER,
  );

  useEffect(() => {
    let isMounted = true;
    let retryCount = 0;
    const maxRetries = 5;

    if (!src || src.trim() === '') {
      setImageUrl(defaultUserProfile || IMG_PLACEHOLDER);
      setShowProgress(false);
      return;
    }

    const loadImage = () => {
      if (!isMounted) return;
      setShowProgress(true);
      const img = new Image();
      img.src = src;

      img.onload = () => {
        if (isMounted) {
          setImageLoaded(true);
          setShowProgress(false);
          setImageUrl(src);
        }
      };

      img.onerror = () => {
        if (isMounted) {
          retryCount++;
          if (retryCount < maxRetries) {
            setTimeout(loadImage, 1000); // retry after 1 second
          } else {
            setShowProgress(false);
            setImageUrl(defaultUserProfile || IMG_PLACEHOLDER);
          }
        }
      };
    };

    loadImage();

    return () => {
      isMounted = false;
    };
  }, [src]);

  return (
    <div className="w-full h-full flex relative" style={style}>
      {showProgress && (
        <div className="absolute top-2 left-2.5 z-10">
          <MediaUploadIndicator percentage={50} />
        </div>
      )}
      <img
        src={imageUrl}
        className={`${classNames ? classNames : 'w-full h-full object-cover'}`}
        alt="refreshable"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        draggable={isDraggable}
        onError={() => {
          setImageUrl(defaultUserProfile || IMG_PLACEHOLDER);
          setShowProgress(false);
        }}
      />
    </div>
  );
};

export default RefreshableImage;
